<router-outlet>
  <app-spinner></app-spinner>
  <app-spinner-component></app-spinner-component>
</router-outlet>
